
// stands for the admin set of colors

export const adminColors = {
    givati:{
        primary_color:"#5c43a3",
        secondary_color:"#b49cf7",
        accent_color:"#ffffff"
    },
    luxury:{
        primary_color:"#000000",
        secondary_color:"#b8860b",
        accent_color:"#aaaaaa"
    },
    oceanMist:{
        primary_color: "#0F4C81",
        secondary_color: "#5DA9E9",
        accent_color: "#F3F7FA",
    },
    sunsetPulse:{
        primary_color: "#7F00FF",
        secondary_color: "#E100FF",
        accent_color: "#FFD6FF",
    },
  }